import { lazy } from "react";
export const Home = lazy(() => import("../Pages/Home/Home"));
export const Login = lazy(() => import("../Pages/auth/Login/Login"));
export const Otp = lazy(() => import("../Pages/auth/Otp/Otp"));
export const Profile = lazy(() => import("../Pages/Profile/Profile"));
export const AddAgent = lazy(() => import("../Pages/AddAgent/AddAgent"));
export const AddNewSalaryGrade = lazy(() =>
  import("../Pages/AddNewSalaryGrade/AddNewSalaryGrade")
);
export const AgentsList = lazy(() => import("../Pages/AgentsList/AgentsList"));

export const AllTemplates = lazy(() =>
  import("../Pages/AllTemplates/AllTemplates")
);
export const AddTemplate = lazy(() =>
  import("../Pages/AddTemplate/AddTemplate")
);
export const AddProject = lazy(() => import("../Pages/AddProject/AddProject"));
export const JobDescriptions = lazy(() =>
  import("../Pages/JobDescriptions/JobDescriptions")
);
export const Projects = lazy(() =>
  import("../Pages/Projects/ProjectsList/ProjectsList")
);
export const ProjectDetails = lazy(() =>
  import("../Pages/Projects/ProjectDetails/ProjectDetailsTabs.jsx")
);
export const AllSalaryGrade = lazy(() =>
  import("../Pages/AllSalaryGrades/AllSalaryGrades")
);
export const SearchSalaryGrade = lazy(() =>
  import("../Pages/SearchSalaryGrade/SearchSalaryGrade")
);

export const AllJobDescription = lazy(() =>
  import("../Pages/AllJobDescriptions/AllJobDescriptions")
);
export const UserJobDescription = lazy(() =>
  import("../Pages/UserJobDescriptions/UserJobDescriptions")
);
export const NoPermissions = lazy(() =>
  import("../Pages/NoPermissions/NoPermissions")
);

export const RoleList = lazy(() => import("../Pages/RoleList/RoleList"));
export const AddRole = lazy(() => import("../Pages/AddRole/AddRole"));
export const Proposal = lazy(() =>
  import("../Pages/Operations/Proposals/ProposalStepper/ProposalStepper")
);
export const ProposalList = lazy(() =>
  import("../Pages/Operations/Proposals/ProposalList/ProposalList")
);
export const Deals = lazy(() =>
  import("../Pages/Operations/Deals/DealsList/DealsList")
);

export const BiddingList = lazy(() =>
  import("../Pages/Operations/Biddings/BiddingList/BiddingList")
);

export const AddBidding = lazy(() =>
  import("../Pages/Operations/Biddings/AddBidding/AddBidding")
);
export const ForgetPassword = lazy(() =>
  import("../Pages/auth/ForgetPassword/ForgetPassword")
);
export const ResetPassword = lazy(() =>
  import("../Pages/auth/ResetPassword/ResetPassword")
);

export const BusinessAllocation = lazy(() =>
  import("../Pages/BusinessAllocation/BusinessAllocation")
);

export const AllocationResources = lazy(() =>
  import("../Pages/BusinessAllocation/AllocationResources")
);
export const Financial = lazy(() => import("../Pages/Financial/FinancialNtp"));
export const UserTasks = lazy(() => import('../Pages/UserTasks/UserTasks'));
export const UserProjects = lazy(() => import('../Pages/UserTasks/UserProjects'));
export const ResourceUtilization = lazy(() => import('../Pages/ResourceUtilization/ResourceUtilization'));

export const SingleDeal = lazy(() => import('../Pages/Operations/Deals/SingleDeal.jsx'));

